import React, {useEffect, useLayoutEffect, useState} from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../dialog/dialog';
import {Button} from '../primitives/button/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../primitives/select/select';
import {Input} from '../primitives/imput/input';
import {Checkbox} from '../primitives/checkbox/checkbox';
import {IMaskInput} from "react-imask";

import {cn} from '../../../lib/utils'

import {useConsentStore} from "../../../lib/store/consent-store";
import {useSendForm} from "../../../lib/hooks/use-send-form";

interface PaymentsItemProps {
  payment: {
    title: string;
    dialogTitle: string;
    celtype: string
  };
}

const downpaymentList = ['20%-30%', '30%-50%', 'более 50%'];


const downpaymentTermList = ['1-10 лет', '10-20 лет', '20-30 лет'];
const downpaymentTermList1 = ['1 год', '2 года', '3 года'];
const downpaymentList1 = ['25%-30%', '30%-50%', 'более 50%'];

export const PaymentsItem = ({payment}: PaymentsItemProps) => {
  const [initialPay, setInitialPay] = useState(downpaymentList);
  const [term, setTerm] = useState(downpaymentTermList);
  const consent = useConsentStore(state => state.consent);
  const updateConsent = useConsentStore(state => state.updateConsent);

  const [termsChecked, setTermsChecked] = useState(false);
  const [termsError, setTermsError] = useState(false)
  const [fieldsError, setFieldsError] = useState(false)

  const [success, setSuccess] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    text: `Варианты оплаты - ${payment.title}`
  })

  useEffect(() => {
    setFieldsError(false)
  }, [formData])

  useEffect(() => {
    setTermsError(false)
  }, [termsChecked]);

  const handleInputChange = (value: string, name: string) => {
    setFormData({...formData, [name]: value})
  }

  const validateFormAndSend = () => {
    if (formData.name === '' || formData.phone === '') {
      setFieldsError(true)
      return
    }

    if (formData.phone !== '') {
      const cleaned = formData.phone.replace(/\D/g, '');
      const isDigitsOnly = /^\d+$/.test(cleaned);
      const isValidLength = cleaned.length >= 10 && cleaned.length <= 15;

      if (isDigitsOnly && isValidLength) {

      } else {
        setFieldsError(true)
        return
      }
    }

    if (!termsChecked) {
      setTermsError(true)
      return
    }

    sendForm(formData, payment.celtype, () => {
      setSuccess(true)
    })
  }

  const {sendForm, isPending, error} = useSendForm()

  useLayoutEffect(() => {
    if (payment.title === 'Рассрочка') {
      setInitialPay(downpaymentList1);
      setTerm(downpaymentTermList1);
    }
  }, []);
  return (
    <div className="">
      <h5 className="text-center uppercase text-xl">{payment.title}</h5>
      <div className="w-[100px] h-[2px] bg-plt-secondary mx-auto mt-[14px]"/>
      <Dialog>
        <DialogTrigger asChild>
          <Button className="mt-[14px] ">Узнать подробнее</Button>
        </DialogTrigger>
        <DialogContent className="border-none bg-plt-white w-[345px] rounded-[20px] px-[50px]">
          <DialogHeader>
            <DialogTitle className="text-center max-w-[235px] mx-auto font-bold text-xl font-open-sans">
              {payment.dialogTitle}
            </DialogTitle>
          </DialogHeader>
          <div className="grid gap-1">
            {payment.title !== '100% оплата' && (
              <>
                <Select>
                  <SelectTrigger className="w-full border-plt-gray">
                    <SelectValue placeholder="Первоначальный взнос"/>
                  </SelectTrigger>
                  <SelectContent className="w-full bg-plt-white">
                    {initialPay.map((item,) => (
                      <SelectItem key={item} value={item}>{item}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                <Select>
                  <SelectTrigger className="w-full border-plt-gray">
                    <SelectValue placeholder="Срок"/>
                  </SelectTrigger>
                  <SelectContent className="w-full bg-plt-white">
                    {term.map((item) => (
                      <SelectItem key={item} value={item}>{item}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </>
            )}

            <Input value={formData.name} onChange={e => handleInputChange(e.target.value, 'name')}
                   placeholder="Ваше имя"/>
            <IMaskInput
              value={formData.phone}
              onAccept={value => handleInputChange(value, 'phone')}
              mask={'+7 (000) 000-00-00'}
              placeholder={'Ваш телефон'}
              className={cn(
                'ym-record-keys placeholder:text-plt-dark-gray selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-plt-gray flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                'rounded-[5px]'
              )}/>
            <Button disabled={isPending} onClick={() => validateFormAndSend()}>Получить расчет</Button>
            {termsError &&
                <p className='text-xs text-red-500'>Пожалуйста, дайте согласие на обработку персональных данных</p>}
            {fieldsError && <p className='text-xs text-red-500'>Пожалуйста, заполните все поля перед отправкой</p>}
          </div>
          {success &&
              <p className='py-3 rounded text-center text-xs text-green-500 border border-solid border-green-500'>Форма
                успешно
                отправлена, спасибо!</p>}
          <div className="flex items-center gap-2">
            <Checkbox checked={termsChecked} onCheckedChange={checked => setTermsChecked(checked === true)}
                      id="payment-terms" className="border-plt-dark-gray"/>
            <label
              htmlFor="payment-terms"
              className="text-[10px] text-plt-dark-gray"
            >
              Нажимая кнопку «Получить расчет», вы даете согласие на обработку
              персональных данных и соглашаетесь с политикой конфиденциальности
            </label>
          </div>
          <div className="flex items-center gap-2">
            <Checkbox checked={consent} onCheckedChange={(checked) => updateConsent(checked === true)}
                      className="border-plt-dark-gray"/>
            <label className="text-[10px] text-plt-dark-gray">
              Я ознакомлен (-на) с правилами обработки куки
            </label>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
